import React, { useState,useRef } from "react";
import { Empty, Input, Button } from "antd";
import { CheckOutlined, CloseOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import editIcon from "../../assets/edit.svg";
import PieChart from "../PieChart";
import StackChart from "../StackChart";

import "./interviewCardTable.scss";


export default function InterviewCardTable({
    isClickable = false,
    titleList,
    data,
    isResumePage = false,
    isEditField = false,
    editFieldHandler,
    setCurrentView,
    resumeProfileHandler,
    shortTable
}) {
    const navigate = useNavigate();
    const [isEditActive, setIsEditActive] = useState(false);
    const [activeFieldID, setActiveFieldID] = useState();
    const [activeRowID, setActiveRowID] = useState();
    const [editInput, setEditInput] = useState(""); // State to hold input value
    const [editInputKey, setEditInputKey] = useState("");
    const inputRef = useRef(null);

    console.log("InterviewCardTable", data);
    
    if (!data) {
        return <Empty style={{ margin: "60px" }} />;
    }

    const focusInputField = () => {
        if (inputRef.current) {
            inputRef.current.focus();
        }
    };

    return (
        <div className="interviewcardtable-wrapper">
            <div
                className="rtable-title-wrapper"
                style={{
                    gridTemplateColumns: shortTable?'2fr 2fr 2fr 2fr':`1fr 2fr 2fr repeat(${titleList.length-3}, 1fr)`
                }}
            >
                {titleList.map((title) => (
                    <div className="rtable-title">{title}
                    </div>
                ))}
            </div>
            {data?.map((table, rowIndex) => (
                <div
                    key={table.id}
                    className="rtable-info-wrapper"
                    style={{
                        gridTemplateColumns: shortTable?'2fr 2fr 2fr 2fr':`1fr 2fr 2fr repeat(${titleList.length-3}, 1fr)`,
                        cursor: isClickable && "pointer",
                    }}
                >
                    {Object.keys(table)?.map((tableInfo, idx) => (
                        <div className="rtable-info">
                            {isEditField ? (
                                <div className="edit-field-wrapper">
                                   <>
                                            {tableInfo === "id"
                                                ? rowIndex + 1
                                                : table[tableInfo]}
                                  </>
                                </div>
                            ) : (
                                table[tableInfo]
                            )}
                        </div>
                    ))}
                </div>
            ))}
        </div>
    );
}
